import clock from "./clock";
import display from "./display";
import { Handler } from "./handler";
import scoreboard from "./scoreboard";
import { dotPad, upperFirst } from "./util";

export class Score extends Handler {
    private side: string;
    private val: number = 0;

    constructor(side: string, val: number) {
        super();

        this.side = side;
        this.val = val;
    }

    boot(): void {
        const sideF = upperFirst(this.side) as "Home" | "Guest";
        const newScore: number = scoreboard[`adjust${sideF}Score`](this.val);

        const valString = (this.val > 0 ? "+" : "") + String(this.val);
        display.line1(`TEAM SCORE- ${valString}`);
        display.line2(`${this.side.toUpperCase()} ${dotPad(newScore, 3)}`);

        clock.displayTimeAndScoreAfter1Second();
        clock.popHandler();
    }
}
